import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import { Link } from "@mui/material";

//Literature Link
// Example:
{/* 
<LiteratureLink pmid={row.pmid}/>
*/}

const LiteratureLink = (props) => {  
     return (
      <Link href={'https://pubmed.ncbi.nlm.nih.gov/' + props.pmid} target="_blank" rel="noopener noreferrer">
        {props.pmid}
      </Link>
    )
            }

export default LiteratureLink